module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagMappingConditionRightInput.conditionMatches":"Matches","tagMappingConditionRightInput.conditionMatch":"Match","tagMappingConditionRightInput.matchesDescription":"Condition will pass if any matches are true"}}')
  delete Component.options._Ctor
}
